// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import singleLocation from './routes/single-location';
import micro from './routes/microModal';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  singleLocation,
  micro,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js